var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgICrm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_2262)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.11111C0 0.497461 0.447715 0 1 0H19C19.5523 0 20 0.497461 20 1.11111V14.4444C20 15.0581 19.5523 15.5556 19 15.5556H11.5V17.7678C11.6428 17.8368 12.6096 18.2797 13.9827 18.3311C14.2653 18.3417 14.5 18.5916 14.5 18.9058V19.9975H11.5V20H8.5V19.9975H5.5V18.9058C5.5 18.5916 5.73475 18.3417 6.01735 18.3311C7.39035 18.2797 8.35705 17.8368 8.5 17.7678V15.5556H1C0.447715 15.5556 0 15.0581 0 14.4444V1.11111ZM11 5H9V12.7778H11V5ZM5 2.22222H7V12.7778H5V2.22222ZM15 8.33333H13V12.7778H15V8.33333Z",
    fill: "#CD6EE5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_2262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgICrm);
export default __webpack_public_path__ + "static/media/i_crm.2f3918d54363a4464491521280f18bc3.svg";
export { ForwardRef as ReactComponent };